import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sheba-arrow-down-icon',
  templateUrl: 'arrow-down.svg',
  host: {
    class: 'contents'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArrowDownIcon { }
